import { Injectable } from '@angular/core';
import { PaypalButtonStyleModel } from '../../models/settings/client-area';
declare let paypal: any;

@Injectable()
export class PaypalService {

    constructor(
    ) {
    }

    private isPaypalScriptLoaded: boolean = false;
    public isError = false;
    public errMessage = "";

    public loadPaypalService(externalScriptLink, createPaypalPaymentAPI, executePaypalPaymentAPI, data, paypalBtnStyle: PaypalButtonStyleModel, UsePaypalProduction = true) {
        //-- Load paypal script if it is not already loaded, else only render a paypal button
        if (!this.isPaypalScriptLoaded) {
            this.loadExternalScript(externalScriptLink).then(() => {
                this.renderPaypalBtn(externalScriptLink, createPaypalPaymentAPI, executePaypalPaymentAPI, data, paypalBtnStyle, UsePaypalProduction);
            });
        }
        else {
            this.renderPaypalBtn(externalScriptLink, createPaypalPaymentAPI, executePaypalPaymentAPI, data, paypalBtnStyle, UsePaypalProduction);
        }
    }

    private loadExternalScript(scriptUrl: string) {
        return new Promise((resolve, reject) => {
            const scriptElement = document.createElement('script');
            scriptElement.src = scriptUrl;
            scriptElement.onload = resolve;
            document.body.appendChild(scriptElement);
            this.isPaypalScriptLoaded = true;
        })
    }

    private renderPaypalBtn(externalScriptLink, createPaypalPaymentAPI, executePaypalPaymentAPI, data: any, paypalBtnStyle: PaypalButtonStyleModel, UsePaypalProduction) {
        let styleObj = this.getPaypalBtnStyle(paypalBtnStyle);
        
        paypal.Button.render({

            env: UsePaypalProduction ? 'production' : 'sandbox', /* sandbox | production */

            /* Show the buyer a 'Pay Now' button in the checkout flow */
            commit: true,
            locale: 'it_IT',


            style: styleObj,

            /* payment() is called when the button is clicked */
            payment: function () {
                /* Make a call to your server to set up the payment */
                return paypal.request.post(createPaypalPaymentAPI, data)
                    .then(response => {
                        return response.id;
                    });
            },

            /* onAuthorize() is called when the buyer approves the payment */
            onAuthorize: function (orderData, actions) {

                //-- Generating of execute payment object that we need on server side
                var executePaymentObj = {
                    paymentID: orderData.paymentID,
                    payerID: orderData.payerID,
                    intent: orderData.intent,
                    orderID: orderData.orderID,
                    paymentToken: orderData.paymentToken,
                    returnUrl: orderData.returnUrl,
                    CustomerId: data.CustomerId,
                    //-- This is our orderId paypal also returns property with same name, so we renamed our OrderId property
                    CustomerOrderId: data.OrderId,
                    Lang: data.Lang
                };

                /* Make a call to your server to execute the payment */
                return paypal.request.post(executePaypalPaymentAPI, executePaymentObj)
                    .then(res => {
                        this.isError = res.IsError;
                        if (!res.IsError) this.isError = false;

                        this.errMessage = res.message;
                        if (!res.message) this.errMessage = "";

                        if (this.isError) {
                            window.location.href = `${orderData.returnUrl}&orderId=${executePaymentObj.CustomerOrderId}&isError=${this.isError}&message=${this.errMessage}`;
                        }
                        else {
                            window.location.href = `${orderData.returnUrl}&orderId=${executePaymentObj.CustomerOrderId}&isError=${this.isError}`;
                        }
                    }).catch(err => {
                        window.location.href = `${orderData.returnUrl}&orderId=${executePaymentObj.CustomerOrderId}&isError=true&message=${err.message}`;
                    })
            }
        }, '#paypal-btn');
    }


    getPaypalBtnStyle(paypalBtnStyle: PaypalButtonStyleModel) {
        let styleObj = {};

        if (paypalBtnStyle) {
            let height = this.getPaypalBtnHeight(paypalBtnStyle.PaypalButtonHeight);

            styleObj = {
                color: paypalBtnStyle.PaypalButtonColor || 'gold',
                shape: paypalBtnStyle.PaypalButtonShape || 'rect',
                label: paypalBtnStyle.PaypalButtonLabel || 'paypal',
                height: height || 40,
                tagline: paypalBtnStyle.PaypalButtonTagline || false,
                size: paypalBtnStyle.PaypalButtonSize || 'responsive'
            }
        }
        else {
            styleObj = {
                color: 'gold',
                shape: 'rect',
                label: 'paypal',
                height: 40,
                tagline: false,
                size: "responsive"
            }
        }

        return styleObj;
    }

    getPaypalBtnHeight(paypalButtonHeight: string) {
        let retVal = 40;
        if (paypalButtonHeight) {
            if (paypalButtonHeight === 'small')
                retVal = 30;
            else if (paypalButtonHeight === 'large')
                retVal = 50;
        }

        return retVal;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/paypal.service.ts